/* ==========================================================================
   Cube Club x Thrudaruf - card, rail and spotlight behaviour
   THD-CUB-2026-01 - v1.1 - 5 Aug 2026
   No dependencies. Everything degrades to a working page without it.
   ========================================================================== */
(function () {
  'use strict';
  if (window.__tdfBooted) return;
  window.__tdfBooted = true;

  /* ---------- card swatches: swap image, price and cart variant in place ---------- */
  function bindCard(card) {
    if (card.dataset.tdfBound) return;
    card.dataset.tdfBound = '1';

    var sws = card.querySelectorAll('[data-tdf-sw]');
    if (!sws.length) return;

    var img      = card.querySelector('[data-tdf-card-img]');
    var priceEl  = card.querySelector('[data-tdf-price]');
    var cmpEl    = card.querySelector('[data-tdf-compare]');
    var varInput = card.querySelector('[data-tdf-varid]');
    var atc      = card.querySelector('[data-tdf-atc]');
    var swLabel  = card.querySelector('[data-tdf-swlabel]');
    var link     = card.querySelector('.tdf-card__media');
    var nameLink = card.querySelector('.tdf-card__name a');

    sws.forEach(function (sw) {
      sw.addEventListener('click', function () {
        sws.forEach(function (o) { o.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');

        var d = sw.dataset;
        if (img && d.variantImage) img.src = d.variantImage;
        if (priceEl && d.variantPrice) priceEl.innerHTML = d.variantPrice;
        if (cmpEl) {
          if (d.variantCompare) { cmpEl.innerHTML = d.variantCompare; cmpEl.hidden = false; }
          else { cmpEl.innerHTML = ''; cmpEl.hidden = true; }
        }
        if (varInput && d.variantId) varInput.value = d.variantId;
        if (swLabel && d.variantLabel) swLabel.textContent = d.variantLabel;
        if (d.variantUrl) {
          if (link) link.href = d.variantUrl;
          if (nameLink) nameLink.href = d.variantUrl;
        }
        if (atc) {
          var available = d.variantAvailable === 'true';
          atc.disabled = !available;
          atc.textContent = available ? 'Add to cart' : 'Sold out';
        }
      });
    });
  }

  /* ---------- rail: progress ticks follow the mobile scroller ---------- */
  function bindRail(scroller) {
    if (scroller.dataset.tdfBound) return;
    scroller.dataset.tdfBound = '1';

    var rail  = scroller.closest('.tdf-rail');
    var ticks = rail && rail.querySelector('[data-tdf-ticks]');
    if (!ticks) return;

    var dots  = ticks.querySelectorAll('i');
    var cells = scroller.querySelectorAll('.tdf-rail__cell');
    if (!dots.length || !cells.length) return;

    var frame = null;
    scroller.addEventListener('scroll', function () {
      if (frame) return;
      frame = requestAnimationFrame(function () {
        frame = null;
        var left = scroller.scrollLeft;
        var best = 0, bestD = Infinity;
        cells.forEach(function (c, i) {
          var d = Math.abs(c.offsetLeft - scroller.offsetLeft - left);
          if (d < bestD) { bestD = d; best = i; }
        });
        dots.forEach(function (dot, i) { dot.classList.toggle('is-on', i === best); });
      });
    }, { passive: true });
  }

  /* ---------- spotlight ---------- */
  function bindSpotlight(sec) {
    if (sec.dataset.tdfBound) return;
    sec.dataset.tdfBound = '1';

    var stage   = sec.querySelector('[data-tdf-sp-stage]');
    var thumbs  = sec.querySelectorAll('[data-tdf-sp-thumb]');
    var opts    = sec.querySelectorAll('[data-tdf-sp-opt]');
    var priceEl = sec.querySelector('[data-tdf-sp-price]');
    var wasEl   = sec.querySelector('[data-tdf-sp-was]');
    var saveEl  = sec.querySelector('[data-tdf-sp-save]');
    var emiEl   = sec.querySelector('[data-tdf-sp-emi]');
    var varId   = sec.querySelector('[data-tdf-sp-varid]');
    var atc     = sec.querySelector('[data-tdf-sp-atc]');
    var sticky  = sec.querySelector('[data-tdf-sp-sticky]');
    var skPrice = sec.querySelector('[data-tdf-sp-sk-price]');
    var skTitle = sec.querySelector('[data-tdf-sp-sk-title]');
    var skBtn   = sec.querySelector('[data-tdf-sp-sk-btn]');
    var showSave = saveEl && !saveEl.hasAttribute('hidden');

    thumbs.forEach(function (t) {
      t.addEventListener('click', function () {
        thumbs.forEach(function (o) { o.setAttribute('aria-current', 'false'); });
        t.setAttribute('aria-current', 'true');
        if (stage && t.dataset.full) { stage.removeAttribute('srcset'); stage.src = t.dataset.full; }
      });
    });

    opts.forEach(function (o) {
      o.addEventListener('click', function () {
        if (o.disabled) return;
        opts.forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        o.setAttribute('aria-pressed', 'true');

        var d = o.dataset;
        if (stage && d.variantImage) { stage.removeAttribute('srcset'); stage.src = d.variantImage; }
        if (priceEl && d.variantPrice) priceEl.innerHTML = d.variantPrice;

        if (wasEl) {
          if (d.variantCompare) { wasEl.innerHTML = d.variantCompare; wasEl.hidden = false; }
          else { wasEl.innerHTML = ''; wasEl.hidden = true; }
        }
        if (saveEl) {
          if (showSave && d.variantSave) { saveEl.textContent = 'Save ' + d.variantSave + '%'; saveEl.hidden = false; }
          else { saveEl.textContent = ''; saveEl.hidden = true; }
        }
        if (emiEl) emiEl.innerHTML = d.variantEmi ? d.variantEmi + '/mo &middot; no-cost EMI over 12 months' : '';
        if (varId && d.variantId) varId.value = d.variantId;
        if (atc) {
          var avail = d.variantAvailable === 'true';
          atc.disabled = !avail;
          atc.textContent = avail ? 'Add to cart' : 'Sold out';
        }
        if (skPrice && d.variantPrice) skPrice.innerHTML = d.variantPrice;
        if (skTitle && d.variantTitle) skTitle.textContent = d.variantTitle;
      });
    });

    if (skBtn && atc) {
      skBtn.addEventListener('click', function () { atc.click(); });
    }

    /* sticky bar appears once the buy box has scrolled past */
    if (sticky && atc && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          sticky.classList.toggle('is-on', !e.isIntersecting && e.boundingClientRect.top < 0);
          sticky.setAttribute('aria-hidden', sticky.classList.contains('is-on') ? 'false' : 'true');
        });
      }, { threshold: 0 });
      io.observe(atc);
    }
  }

  function init(root) {
    var r = root || document;
    r.querySelectorAll('[data-tdf-card]').forEach(bindCard);
    r.querySelectorAll('[data-tdf-scroller]').forEach(bindRail);
    r.querySelectorAll('[data-tdf-spotlight]').forEach(bindSpotlight);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
